import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from '@components/shell';
import CameraPlaybackPage from '@pages/CameraPlaybackPage';
import NvrModulePage from '@pages/NvrModulePage';
import LoginPage from '@pages/LoginPage';
import BootstrapSuperAdminPage from '@pages/BootstrapSuperAdminPage';
import UsersAdminPage from '@pages/UsersAdminPage';
import RolesAdminPage from '@pages/RolesAdminPage';
import { AuthProvider } from '@auth/AuthContext';
import { RequireAuth, RequirePermission, RequireSuperAdmin } from '@auth/guards';

export default function App(): JSX.Element {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppShell>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/bootstrap" element={<BootstrapSuperAdminPage />} />
            <Route
              path="/dashboard"
              element={
                <RequireAuth>
                  <RequirePermission permission="live_view">
                    <NvrModulePage />
                  </RequirePermission>
                </RequireAuth>
              }
            />
            <Route
              path="/cameras/:id/playback"
              element={
                <RequireAuth>
                  <RequirePermission permission="live_view">
                    <CameraPlaybackPage />
                  </RequirePermission>
                </RequireAuth>
              }
            />
            <Route
              path="/admin/users"
              element={
                <RequireAuth>
                  <RequirePermission permission="user_management">
                    <UsersAdminPage />
                  </RequirePermission>
                </RequireAuth>
              }
            />
            <Route
              path="/admin/roles"
              element={
                <RequireAuth>
                  <RequireSuperAdmin>
                    <RolesAdminPage />
                  </RequireSuperAdmin>
                </RequireAuth>
              }
            />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </AppShell>
      </BrowserRouter>
    </AuthProvider>
  );
}
